import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { isEmpty } from 'ramda';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '~/features/common/redux/actions';
import * as selector from '~/features/common/redux/selector';
import { Container, Box, Image, Input, Field, Control, Help } from 'bloomer';

import Loading from '~/features/common/Loading';
import Avatar from '~/features/common/Avatar';
import Icon from '~/features/common/Icon';
import { currentImpersonatorToken, hasImpersonatedCoachToken } from '~/common/auth';

export class DefaultPage extends React.PureComponent {
  static propTypes = {
    children: PropTypes.node,
  };

  state = {
    isMobile: null,
    loading: true,
    filtered: [],
    query: '',
  };

  get isLoading() {
    return this.state.loading;
  }

  get hasUsers() {
    return this.props.common && this.props.common.channels;
  }

  get hasChannels() {
    return this.props.common.channels && this.props.common.channels.length > 0;
  }

  get isAuthenticated() {
    return this.props.session && this.props.session.authenticated;
  }

  async componentDidMount() {
    setTimeout(() => {
      this.setState({
        loading: false,
        isMobile: window ? window.innerWidth < 420 : false,
      });
    }, 2000);
  }

  UNSAFE_componentWillReceiveProps = nextProps => {
    if (nextProps.channels) {
      this.setState({ filtered: nextProps.channels });
    }
  };

  handleChange = e => {
    this.setState({ query: e.currentTarget.value }, () => {
      this.applyFilteredKeyword();
    });
  };

  handleRedirect = () => {
    if (currentImpersonatorToken() && !hasImpersonatedCoachToken()) {
      window.location.href = '/impersonation-options';
    } else {
      setTimeout(() => {
        window.location.href = '/overview';
      }, 1000);
    }
  };

  applyFilteredKeyword = () => {
    let filtered = !isEmpty(this.state.query)
      ? this.props.common.channels.filter(f => f.title.toLowerCase().match(this.state.query))
      : this.props.common.channels;

    this.setState({ filtered });
  };

  renderChannelList = () => {
    const { filtered } = this.state;
    return (
      <React.Fragment>
        <Box className="is-borderless is-shadowless is-marginless is-flex has-input">
          <Field className="is-fullwidth">
            <Control hasIcons>
              <Input
                type="text"
                isSize="large"
                isFullWidth
                placeholder="Search member"
                onChange={this.handleChange}
                autoFocus
              />
              <Icon name="search" />
              <Help>{filtered && filtered.length} members</Help>
            </Control>
          </Field>
        </Box>
        <Box className="is-borderless is-shadowless is-flex has-list">
          {!this.props.common.getChannelsPending ? (
            <React.Fragment>
              {filtered.map((u, key) => (
                <Link to={`/${u.id}/chat`} key={key} className="is-flex with-avatar">
                  <Avatar name={u.title} url={u.photo} inverted />
                  <span>{u.title}</span>
                </Link>
              ))}
            </React.Fragment>
          ) : (
            <Loading />
          )}
        </Box>
      </React.Fragment>
    );
  };

  renderAuthLink = () => {
    return (
      <div className="is-flex has-actions">
        <Link to="/session/login" className="button is-white has-text-primary">
          Login
        </Link>
      </div>
    );
  };

  render() {
    const label = this.isAuthenticated ? 'Authenticated' : 'Not Authenticated';

    return (
      <div className="naluri-page">
        <Container isFluid isFullWidth>
          <Box className="is-borderless is-shadowless has-text-centered">
            <Image src={require('../../images/logo.svg')} />
            <p>User is {label}</p>
            {this.isLoading ? (
              <Loading />
            ) : !this.isAuthenticated ? (
              this.renderAuthLink()
            ) : (
              this.handleRedirect()
            )}
          </Box>
        </Container>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    router: state.router,
    common: state.common,
    session: state.session,
    channels: selector.getPrivateChannel()(state.common),
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultPage);



// WEBPACK FOOTER //
// ./src/features/home/DefaultPage.js